// @flow

import { streamChat } from '../../../../services/aiChatStream';

const TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

/**
 * Starts a chat stream with unified event handling
 * @param {Object} config - Stream configuration
 * @param {string} config.threadId - Thread ID for conversation memory
 * @param {string} config.prompt - User prompt text
 * @param {Function} config.onEvent - Unified event handler (status, data) => void
 * @param {Function} config.onError - Error handler (message) => void
 * @param {Function} config.onClose - Close handler () => void
 * @returns {Object} Object with cancel function
 */
export async function startChatStream({
  threadId,
  prompt,
  onEvent,
  onError,
  onClose,
}) {
  if (!threadId || !prompt) {
    throw new Error('threadId and prompt are required');
  }

  return await streamChat(
    threadId,
    {
      message: prompt,
      resourceOverride: 'chat',
    },
    {
      onCustomEvent: (eventPayload) => {
        const { status, data } = eventPayload || {};
        if (status && typeof onEvent === 'function') {
          onEvent(status, data);
        }
      },
      onError: (message) => {
        if (typeof onError === 'function') {
          onError(message);
        }
      },
      onClose: () => {
        if (typeof onClose === 'function') {
          onClose();
        }
      },
    },
    { timeoutMs: TIMEOUT_MS }
  );
}
